import React from 'react';
import { Form } from '@remix-run/react';
import CallIcon from '~/assets/icons/contact/CallIcon';
import EmailIcon from '~/assets/icons/contact/Email';

type ContactUsProps = {
  actionData?: any;
  navigation?: any;
};

export default function ContactUs({ actionData, navigation }: ContactUsProps) {
  const isSubmitting = navigation?.state === 'submitting';
  const formRef = React.useRef<HTMLFormElement>(null);

  React.useEffect(() => {
    if (actionData?.ok === true) {
      formRef.current?.reset();
    }
  }, [actionData]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 md:p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl w-full items-center">
        <div className="bg-white shadow-2xl rounded-lg p-6 flex flex-col justify-center h-auto">
          <div className="flex flex-col divide-y divide-gray-200 space-y-6 md:space-y-0">
            <div className="flex flex-col items-center py-4 text-center">
              <div className="flex justify-center items-center w-12 h-12 rounded-full ">
                <EmailIcon />
              </div>
              <div className="text-lg pt-4 font-medium text-gray-800">
                Email
              </div>
            </div>

            <div className="flex flex-col items-center py-4 text-center">
              <div className="flex justify-center items-center w-12 h-12 rounded-full ">
                <CallIcon />
              </div>
              <div className="text-lg pt-4 font-medium text-gray-800">
                Number
              </div>
            </div>
          </div>
        </div>

        <div className="md:col-span-2 bg-white rounded-lg shadow p-6 md:p-8">
          <h2 className="text-2xl text-black font-semibold mb-2">
            Just Say Hello!
          </h2>
          <p className="text-sm text-[#808080] max-w-[480px] mb-6">
            Do you fancy saying hi to me or you want to get started with your
            project and you need my help? Feel free to contact me.
          </p>

          <Form method="post" ref={formRef} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="fullName"
                placeholder="VAPE STORE"
                required
                className="w-full border border-[#E6E6E6] rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
              <input
                type="email"
                name="email"
                placeholder="vapestore@gmail.com"
                required
                className="w-full border border-[#E6E6E6] rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            <input
              type="text"
              name="subject"
              placeholder="Hello"
              className="w-full border border-[#E6E6E6] rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />

            <textarea
              name="message"
              placeholder="Subjects"
              rows={3}
              required
              className="w-full border border-[#E6E6E6] text-[#999999] rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />

            <div className="flex items-center">
              <input
                type="checkbox"
                name="consentToContact"
                className="h-4 w-4 text-purple-600"
              />
              <span className="ml-2 text-gray-700">
                I consent to be contacted
              </span>
            </div>

            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full md:w-[400px] bg-primary text-white font-medium rounded-md py-4 hover:bg-purple-800 transition"
              >
                {isSubmitting ? 'Sending...' : 'Send a Message'}
              </button>
            </div>

            {actionData?.ok && (
              <div className="p-4 bg-green-50 text-green-800 border border-green-200 rounded-md mt-2">
                Message sent successfully!
              </div>
            )}

            {actionData?.ok === false && actionData.error && (
              <div className="p-4 bg-red-50 text-red-800 border border-red-200 rounded-md mt-2">
                {actionData.error}
              </div>
            )}
          </Form>
        </div>
      </div>
    </div>
  );
}
